// extracted by mini-css-extract-plugin
module.exports = {"Loading":"Loading_Loading__2YKa6","Spinner":"Loading_Spinner__3w8rP"};